module.exports = __webpack_public_path__ + "img/david.10bd754b.jpg";